import { useAppErrorStore } from '@/shared/lib/appErrorStore';
import ErrorDialog from '@/shared/ui/ErrorDialog';

/**
 * Global error popup. Mount once at the app root — the axios response
 * interceptor pushes server errors (`statusCode: "4XX"` / `5XX`, network
 * failures) onto the queue and the first one is rendered as a centered
 * dialog. Dismissing reveals the next one if any are still queued.
 */
export default function GlobalErrorToast() {
  const errors = useAppErrorStore((s) => s.errors);
  const clear = useAppErrorStore((s) => s.clear);
  const current = errors[0];

  if (!current) return null;

  return (
    <ErrorDialog
      open
      title={current.title}
      message={current.message}
      code={current.code}
      onClose={() => clear()}
    />
  );
}
